<template>
  <w-dialog :dialogShow="dialogShow" @handleClose="closeWindow">
    <div slot="content" class="download-content flex-column-center">
      <img src="https://files.wondercv.com/qiuzhao/image/dialogicon_file2.png" alt="">
      <span class="title">微信不支持文件下载</span>
      <p>可发送至邮箱，或打开电脑下载简历<br/>wondercv.com</p>
      <div class="bottom flex-center" @click="closeWindow">知道了</div>
    </div>
  </w-dialog>
</template>

<script>
	import WDialog from '../../components/global/w-dialog'

	export default {
		name: 'wx-download',
		props: {
			dialogShow: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {
			WDialog
		},
		methods: {
			closeWindow () {
				this.$emit('closeWindow')
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  .download-content {
    width: 90vw;
    border-radius: 2px;
    background-color: $color-light;
    padding: 36px 48px 0;
    img {
      width: 60px;
      height: 60px;
      margin-bottom: 24px;
    }
    .title {
      font-size: $font-size-large-x;
      color: $color-title;
      margin-bottom: 18px;
    }
    p {
      text-align: center;
      color: $color-dark-gray;
      margin-bottom: 30px;
      line-height: 20px;
    }
    .bottom {
      width: 90vw;
      height: 60px;
      color: $color-theme;
      border-top: 1px solid #ececec;
      font-size: $font-size-medium-x;
    }
  }
</style>
